<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account-child"
          :title="$route.params.id ? $t('Edit Child') : $t('New Child')"
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.first_name"
                  :label="$t('first_name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="first_name"
                  :error-messages="errors.collect('first_name')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.last_name"
                  :label="$t('last_name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="last_name"
                  :error-messages="errors.collect('last_name')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.tax"
                  :label="$t('tax')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="tax"
                  :error-messages="errors.collect('tax')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="formValues.gender"
                  :items="genders"
                  item-text="name"
                  item-value="id"
                  :label="$t('gender')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="gender"
                  :error-messages="errors.collect('gender')"
                >
                </v-select>
              </v-col>
              <v-col>
                <base-date-picker
                  v-model="formValues.birth"
                  :label="$t('birth')"
                  :errors="errors.collect('birth')"
                ></base-date-picker>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="formValues.lang"
                  :items="languages"
                  item-text="name"
                  item-value="id"
                  :label="$t('language')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="lang"
                  :error-messages="errors.collect('lang')"
                >
                </v-select>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.phone"
                  :label="$t('phone')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="phone"
                  :error-messages="errors.collect('phone')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-switch
                  v-model="formValues.whatsapp_infos"
                  :label="$t('whatsapp_infos')"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="formValues.school"
                  :items="schools"
                  item-text="name"
                  item-value="id"
                  :label="$t('schools')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="school"
                  :error-messages="errors.collect('school')"
                >
                </v-select>
                <p>
                  <small>{{ $t("school_year_info") }}</small>
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-switch
                  v-model="formValues.leave_alone"
                  :label="$t('leave_alone')"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  v-model="formValues.swimming_help"
                  :label="$t('swimming_help')"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  v-model="formValues.with_diagnostics"
                  :label="$t('with_diagnostics')"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="formValues.allergies"
                  :label="$t('allergies')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="allergies"
                  :error-messages="errors.collect('allergies')"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="formValues.incompatibilities"
                  :label="$t('incompatibilities')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="incompatibilities"
                  :error-messages="errors.collect('incompatibilities')"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col>
                <v-textarea
                  v-model="formValues.risk_group"
                  :label="$t('risk_group')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="risk_group"
                  :error-messages="errors.collect('risk_group')"
                ></v-textarea>
              </v-col> -->
              <v-col>
                <v-textarea
                  v-model="formValues.medicaments"
                  :label="$t('medicaments')"
                  autocomplete="new-password"
                  v-validate=""
                  data-vv-name="medicaments"
                  :error-messages="errors.collect('medicaments')"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="formValues.parents">
              <v-col>
                <v-card color="grey lighten-2">
                  <v-card-text>
                    <p>
                      <strong>{{ $t("People") }}: </strong>
                      <a
                        v-for="(parent, index) in formValues.parents"
                        @click="
                          $router.push({ path: '/be/person/' + parent.id })
                        "
                        :key="index"
                        >{{ parent.first_name }} {{ parent.last_name }} ({{
                          parent.place
                        }})
                      </a>
                    </p>
                    <hr />
                    <h4 class="mt-3">
                      <strong>{{ $t("course_registrations_actual") }}: </strong>
                    </h4>
                    <template v-if="formValues.course_weeks.length">
                      <div class="mt-3">
                        <ul>
                          <li
                            v-for="(week, index) in formValues.course_weeks"
                            :key="index"
                          >
                            <a
                              @click="
                                $router.push({
                                  path: '/be/course/' + week.course_id + '/show'
                                })
                              "
                              >{{ week.course.name }} - {{ week.name }} [{{
                                week.from | formatDate
                              }}
                              - {{ week.to | formatDate }}]
                              <strong v-if="week.pivot.is_waiting">
                                !! {{ $t("course_waiting_list") }}</strong
                              ></a
                            >
                          </li>
                        </ul>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-card-actions class="pl-0">
              <v-btn
                class="mr-4"
                @click="$router.push({ name: 'child.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem } from "../shared/services";
export default {
  name: "app-child-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {},
      permissions: [],
      loading: true,
      genders: [
        {
          id: "m",
          name: this.$t("men")
        },
        {
          id: "f",
          name: this.$t("woman")
        },
        {
          id: "s",
          name: this.$t("divers")
        }
      ],
      schools: [
        {
          id: "kg_1",
          name: "1. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_2",
          name: "2. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_3",
          name: "3. " + this.$t("kinder_garden_year")
        },
        {
          id: "kg_4",
          name: "4. " + this.$t("kinder_garden_year")
        },
        {
          id: "gs_1",
          name: "1. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_2",
          name: "2. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_3",
          name: "3. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_4",
          name: "4. " + this.$t("elementary_school_year")
        },
        {
          id: "gs_5",
          name: "5. " + this.$t("elementary_school_year")
        },
        {
          id: "ms_1",
          name: "1. " + this.$t("middle_school_year")
        },
        {
          id: "ms_2",
          name: "2. " + this.$t("middle_school_year")
        },
        {
          id: "ms_3",
          name: "3. " + this.$t("middle_school_year")
        },
        {
          id: "other",
          name: this.$t("other")
        }
      ],
      languages: [
        {
          id: "de",
          name: this.$t("de")
        },
        {
          id: "it",
          name: this.$t("it")
        }
      ],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ]
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.loading = true;
      fetchItem(this.$route.params.id).then(res => {
        this.formValues = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.formValues.parent = false;
    }
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    }
  },
  methods: {
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "child.index" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
